import React from 'react';
import PropTypes from 'prop-types';
import RoleManagement from '../roleManagement/roleManagementContainer';
import {connect} from 'react-redux';
import UserTree from './userTree';
import {SearchBar, ContainerLoader, UI, User} from '../';
import {OverlayTrigger, Popover} from 'react-bootstrap';
import {Link} from 'react-router';
import DeleteUser from './deleteUserModal';
import {searchUser} from 'api'
import * as Actions from 'actions';

class UsersContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        	search_bar_value : '',
        	search_bar_options : [],
        	search_bar_wait : false,
        	show_results : false,
        	show_user_tree : true,
        	timeout_id : ''
        }

        this.account = '';

        this.handleCreateNewUser = this.handleCreateNewUser.bind(this);
        this.handleSearchBarSelect = this.handleSearchBarSelect.bind(this);
        this.handleSearchBarSubmit = this.handleSearchBarSubmit.bind(this);
        this.handleSearchBarChange = this.handleSearchBarChange.bind(this);
        this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
        this.mapDisplayOption = this.mapDisplayOption.bind(this);
        this.handleSearchBarFocus = this.handleSearchBarFocus.bind(this);
        this.handleSearchBarBlur = this.handleSearchBarBlur.bind(this);
        this.toggleUserTreeShowing = this.toggleUserTreeShowing.bind(this);
        this.handleEndProxyLogin = this.handleEndProxyLogin.bind(this);
    }

		handleCreateNewUser() {
    	this.props.initCreateUser();
    }

    handleSearchBarChange(event) {
    	let _self = this;
    	let value = event.target.value;

    	this.setState({search_bar_value : value});
    	if (value === '') {
    		if(this.state.show_results)
    			this.setState({show_results : false})
    	}
    	else {
    		if(!this.state.show_results) {
    			this.setState({show_results : true})
    		}
				if(!this.state.search_bar_wait) {
					this.setState({search_bar_wait : true})
    			searchUser(value, this.account)
    				.then((docs, err) => {
    					if(err) console.log(err)
    					else {
    						_self.setState({search_bar_options : docs})
    					}
    				})
				}
				else {
					clearTimeout(this.state.timeout_id)
					let timeout_id = setTimeout(() => {
						searchUser(this.state.search_bar_value, this.account)
							.then((docs, err) => {
								if(err) console.log(err)
								else {
									this.setState({search_bar_options : docs})
								}
							})
						this.setState({
							search_bar_wait : false,
							timeout_id : timeout_id
						})
					}, 250)
				}
	    }
		}

		handleSearchBarSelect(index, event) {
			this.setState({search_bar_value : ''})
			this.props.showViewUser(this.state.search_bar_options[index]);
		}

    handleSearchBarSubmit() {
    	this.props.showViewUser(this.state.search_bar_options[0]);
    }

    handleOnKeyDown(event) {
    	if (event.key === 'Enter')
    		this.handleSearchBarSubmit();
    	if (event.key === 'Tab') {
    		if (this.state.search_bar_options.length !== 0){
    			let full_name = this.state.search_bar_options[0].name.first + ' ' +
    				this.state.search_bar_options[0].name.last;

	    		this.setState({search_bar_value : full_name});

	    		this.props.searchUser(
		    		full_name, this.account, (err, docs) => {
		    			this.setState({search_bar_options : docs})
		  			}
					);
    		}
    	}
    }

    mapDisplayOption(option, index) {
    	let full_name = option.name.first + ' ' +
    		option.name.last;

    	return `${full_name}${!option.owner_account? ' (Account Owner)' : ''}`;
    }

    handleSearchBarFocus() {
    	if (this.state.search_bar_value) {
	    	this.setState({show_results : true});
	    	this.props.searchUser(
	    		this.state.search_bar_value, this.account, (err, docs) => {
	    			this.setState({search_bar_options : docs})
	  			}
				);
	    }
    }

    handleSearchBarBlur() {
    	setTimeout(() => {
	    	this.setState({show_results : false});
    	}, 100);
    }

    toggleUserTreeShowing() {
    	if(this.state.show_user_tree)
    		this.setState({show_user_tree : false})
    	else
    		this.setState({show_user_tree : true})
    }

    handleEndProxyLogin() {
    	let account = this.props.users.proxy_account.owner_account || this.props.users.proxy_account._id
    	this.props.leaveSocketChannel(`account-${account}`)
    	this.props.logoutProxyAccount()
    }

    componentWillMount() {
  	  if (!this.props.hasPermission('/Account Management/Users/'))  {
        this.context.router.goBack();
      }
	    this.props.updateFeaturesList(this.props.users.user.features)

      if(this.props.users.proxy_account && this.props.users.user.is_admin)
	    	this.props.beginInitUsers(this.props.users.proxy_account);
	    else
	    	this.props.beginInitUsers();

	    $('.search-bar-input').focus()
    }

    componentWillUpdate(nextProps, nextState) {
    	let cur_pa = this.props.users.proxy_account;
    	let nxt_pa = nextProps.users.proxy_account;

    	if((!cur_pa && nxt_pa != null) || ((cur_pa != null && nxt_pa != null) && cur_pa._id !== nxt_pa._id))
    		this.props.beginInitUsers(nxt_pa)
    	else if(cur_pa != null && !nxt_pa)
    		this.props.beginInitUsers()
    }

    render() {
        var _self = this;
        var toggle_carot_class_name;
        if(this.state.show_user_tree)
        	toggle_carot_class_name = 'fa fa-caret-up'
        else
        	toggle_carot_class_name = 'fa fa-caret-down'

        const addUserPopover = (
        	<Popover
        		id='popover-trigger-hover-focus'
        		title='Add User'>
        		Add user to user tree
        	</Popover>
        )

        const cannotAddUserPopover = (
        	<Popover
        		id='popover-trigger-hover-focus'
        		title='At User Capacity'>
        		This account is at the maximum number of users.
        	</Popover>
        )

        const toggleShowUserTreePopover = (
        	<Popover
        		id='popover-trigger-hover-focus'
        		title='Toggle User Tree'>
        		View/hide the user tree
        	</Popover>
        )

        if(this.props.ui.initializing) {
					return <ContainerLoader />
        }
				else
	        return (
	        	<div>
	        		<DeleteUser />
	        		<UI.Container title="User Management">
		        		{(() => {
		        			if(_self.props.children)
		                return <div className="text-primary">{_self.props.children}</div>
		              else {
		              	return (
			                <div className='users-container animated fadeInDown'>
			                	<div className='row'>
			                		<div className='col-md-4 col-md-offset-8 col-sm-6 col-sm-offset-6 col-xs-12'>
	                      		<SearchBar
	                      			value={this.state.search_bar_value}
	                      			placeHolder='Search For a User'
	                      			onChange={this.handleSearchBarChange}
	                      			onSubmitButtonPress={this.handleSearchBarSubmit}
	                      			options={this.state.search_bar_options}
	                      			onSelect={this.handleSearchBarSelect}
	                      			display={this.mapDisplayOption}
	                      			onBlur={this.handleSearchBarBlur}
	                      			onFocus={this.handleSearchBarFocus}
	                      			onKeyDown={this.handleOnKeyDown}
	                      			autoFocus={true}
	                      			show={this.state.show_results}
	                      			customResultsListClass='list-group search-bar-results-container'
	                      			customListItemClass='list-group-item search-bar-list-item' />
		                    	</div>
	                    	</div>
			                  <div className="text-primary">
			                    <div className="users-inner-container panel">
			                      <div className="row panel-heading users-panel-heading">
			                      	<div className='col-md-10 col-sm-9 col-xs-8'>
					                      <h2 className="panel-title">User Tree</h2>
					                      {(() => {
					                      	if(this.props.users.user &&
					                      		this.props.users.user.is_admin &&
					                      		this.props.users.proxy_account)
					                      	{
					                      		let {proxy_account} = this.props.users
					                      		return (
					                      			<p>
					                      				You are currently logged in to
					                      				{` ${proxy_account.name.first} ${proxy_account.name.last}\'s`} account.{' '}
					                      				<Link
					                      					to='/'
					                      					className='btn btn-default'
					                      					onClick={this.handleEndProxyLogin}>Click Here</Link>{' '}
					                      				to end this session and return to your dashboard.
					                      			</p>
					                      			)
					                      	}
					                      	else {
					                      		return (
					                      				<p className="panel-subtitle">
									                      	Manage your user tree structure by dragging and
									                      	dropping users to different parents.
									                      </p>
					                      			)
					                      	}
					                      })()}
				                      </div>
				                      <div className='pull-right panel-buttons-wrapper'>
				                      	{(() => {
				                      		if(this.props.hasPermission('/Account Management/Users/Create/'))
				                      			if(this.props.users.user.is_admin ||
				                      				((this.props.users.user.users_in_account !== undefined && this.props.users.user.account_user_limit !== undefined) &&
				                      				this.props.users.user.users_in_account < this.props.users.user.account_user_limit)) {

					                      			return (
					                      				<OverlayTrigger
								                      		trigger={['hover', 'focus']}
								                      		placement='bottom'
								                      		overlay={addUserPopover}>
										                      <div
															        			id='create-new-user-button'
															        			className='fa fa-user-plus add-user-button'
															        			onClick={this.handleCreateNewUser}
													        				/>
													        			</OverlayTrigger>
					                      			)
						                      	}
						                      else {
						                      	return (
				                      				<OverlayTrigger
							                      		trigger={['hover', 'focus']}
							                      		placement='bottom'
							                      		overlay={cannotAddUserPopover}>
									                      <div
														        			id='create-new-user-button'
														        			className='fa fa-user-plus disabled-add-user-button'
													        				/>
												        			</OverlayTrigger>
				                      			)
						                      }
				                      	})()}
									        			<OverlayTrigger
				                      		trigger={['hover', 'focus']}
				                      		placement='bottom'
				                      		overlay={toggleShowUserTreePopover}>
											        		<div
											        			id='toggle-show-tree-caret'
											        			className={toggle_carot_class_name}
											        			onClick={this.toggleUserTreeShowing}
											        			/>
											        	</OverlayTrigger>
									        		</div>
			                      </div>
			                      {(() => {
			                      	if(this.state.show_user_tree) {
			                      		return (
			                      			<div className="panel-body" style={{ overflowX: 'scroll' }}>
						                        <div className="row">
						                          <div className="col-xs-12 clearfix">
						                            <UserTree />
						                          </div>
						                        </div>
						                      </div>
			                      		)
			                      	}
			                      })()}
		                      </div>
		                    </div>
		                  {(() => {
		                  	if ((this.props.hasPermission('/Account Management/Roles/Create/') &&
			                  		this.props.hasPermission('/Account Management/Roles/Edit/'))) {
		                  		return (
		                  			<div>
		                  				<hr/>
						                  <RoleManagement />
						                </div>
		                  		)
		                  	}
		                  })()}
		                </div>
	                )
	              }
	        		})()}
	          </UI.Container>
          </div>
        );
    }
}

var mapStateToProps = ({users, ui, roleManagement, features}) => ({users, ui, roleManagement, features})

UsersContainer.contextTypes = {
    router : PropTypes.object
}

export default connect(mapStateToProps, Actions)(UsersContainer);



// WEBPACK FOOTER //
// ./src/browser/components/users/usersContainer.js